import { render, staticRenderFns } from "./h4h_breadcrumb.vue?vue&type=template&id=52d9afe0&"
import script from "./h4h_breadcrumb.vue?vue&type=script&lang=js&"
export * from "./h4h_breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports